/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { Suspense, lazy, useEffect, useState } from "react";
import WhyEai from "../../components/WhyEai";
import Loading from "../../components/Loading";
import { useHyperlink } from "../../contexts/HyperlinkProvider";

const WhyPageAngelAi = lazy(() => import("../../components/WhyPageAngelAi"));

function About() {
    const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [sunwestLink1, setSunwestLink1] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 1);
      const swLink1 = await getHyperLink("websites","swmc",0);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West Mortgage Company, Inc.");
      setSunwestLink1(swLink1 || "Sun West");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);

    return (
        <div>
            <WhyEai angelAiLink={angelAiLink} sunwestLink={sunwestLink} sunwestLink1={sunwestLink1}/>
            <Suspense fallback={<Loading />}>
                <WhyPageAngelAi angelAiLink={angelAiLink} />
            </Suspense>
        </div>
    )
}
export default About;